import wire from '../wire';
import template from './resources.html';

class ResourcesController {
  constructor($rootScope) {
    'ngInject';
    this.account = $rootScope.account;

    this.platformSteps = [
      {
        name: 'Acquisition',
        image: 'https://www.boxcast.com/hubfs/BoxCast_May2016/Icon-Acquisition.png?t=1484855601418',
        link: 'https://www.boxcast.com/product/platform#acquisition',
      },
      {
        name: 'Production',
        image:
          'https://www.boxcast.com/hubfs/BoxCast_May2016/Icon-Video_Production.png?t=1484855601418',
        link: 'https://www.boxcast.com/product/platform#live-production',
      },
      {
        name: 'Compression',
        image: 'https://www.boxcast.com/hubfs/BoxCast_May2016/Icon-Compression.png?t=1484855601418',
        link: 'https://www.boxcast.com/product/platform#compression',
      },
      {
        name: 'Transfer',
        image: 'https://www.boxcast.com/hubfs/BoxCast_May2016/Icon-Transfer.png?t=1484855601418',
        link: 'https://www.boxcast.com/product/platform#transfer',
      },
      {
        name: 'Encoding',
        image: 'https://www.boxcast.com/hubfs/BoxCast_May2016/Icon-Encoding.png?t=1484855601418',
        link: 'https://www.boxcast.com/product/platform#transcoding',
      },
      {
        name: 'Delivery',
        image: 'https://www.boxcast.com/hubfs/BoxCast_May2016/Icon-Delivery.png?t=1484855601418',
        link: 'https://www.boxcast.com/product/platform#delivery',
      },
      {
        name: 'Presentation',
        image:
          'https://www.boxcast.com/hubfs/BoxCast_May2016/Icon-Presentation.png?t=1484855601418',
        link: 'https://www.boxcast.com/product/platform#presentation',
      },
      {
        name: 'Promotion',
        image: 'https://www.boxcast.com/hubfs/BoxCast_May2016/Icon-Promotion.png?t=1484855601418',
        link: 'https://www.boxcast.com/product/platform#promotion',
      },
      {
        name: 'Monetization',
        image:
          'https://www.boxcast.com/hubfs/BoxCast_May2016/Icon-Monetization.png?t=1484855601418',
        link: 'https://www.boxcast.com/product/platform#monetization',
      },
    ];
  }

  openPlatformStep(p) {
    window.open(p.link);
  }

  changeTab(name) {
    this.tab = name;
    window.scrollTo(0, 0);
  }
}

var module = wire('resources', template, ResourcesController, 'ResourcesController');

module.component('resourceCard', {
  transclude: true,
  controllerAs: 'vm',
  bindings: {
    title: '@',
    image: '@',
  },
  template: `
    <div class="resource-card well">
      <div style="display:flex">
        <div class="img-container"
             style="background-image:url({{vm.image}});
                    background-size:cover;
                    background-repeat: no-repeat;
                    background-position: 50% 50%;
                    background-color: #000;">

        </div>
        <div class="content-container">
          <h3>{{vm.title}}</h3>
          <div ng-transclude></div>
        </div>
      </div>
      <div class="clearfix"></div>
    </div>
  `,
});

module.component('resourceArticle', {
  controllerAs: 'vm',
  bindings: {
    name: '@',
    description: '@',
    link: '@',
    type: '@',
  },
  template: `
    <span class="label label-default">
      {{vm.type}}
    </span>
    <h4><a href="{{vm.link}}" target="_blank">{{vm.name}}</a></h4>
    <p>{{vm.description}}</p>
  `,
});

export default module;



// WEBPACK FOOTER //
// ./app/pages/resources/_index.js